<template>
  <div class="course-table-wrapper table-container f-shortcode-courses-table w-flexible-table home-shortcode-table">
    <table :class="{'no-categories' : table.course_groups.length == 1}" class="fixed-layout">
      <colgroup v-if="toShowAbbr">
        <col width="10%">
        <col>
        <col width="30%">
        <col width="10%">
        <col width="20%">
      </colgroup>
      <colgroup v-else>
        <col width="10%">
        <col>
        <col width="20%">
        <col width="20%">
      </colgroup>


      <thead>
        <tr>
          <th class="tcenter" colspan="2">Sophia Course</th>
          <th v-if="toShowAbbr">{{abbr}}</th>
          <th class="tcenter">Credits</th>
          <th class="tcenter">Rating</th>
        </tr>
      </thead>

      <tbody v-for="group in table.course_groups">
        <tr class="equivalence-table-category-row">
          <td class="equivalence-table-category" v-if="toShowAbbr" colspan="5">{{group.title}}</td>
          <td class="equivalence-table-category" v-else colspan="4">{{group.title}}</td>
        </tr>
        <tr v-for="course in group.courses">
          <td>
            <a
              :href="course.path"
              :title="course.title"
              target="_blank"
              class="flex-shortcode-courses-image">
              <img :src="course.image_path">
            </a>
          </td>
          <td class="course-title-cell" data-title="Sophia Course">
            <a
              :href="course.path"
              :title="course.title"
              target="_blank"
              class="flex-shortcode-courses-title">{{course.title}}</a>
          </td>
          <td v-if="toShowAbbr" :data-title="abbr">
            {{course.course_equivalent}}
          </td>
          <td class="tcenter" data-title="Credits">
            {{course.credits}}
          </td>
          <td class="tcenter star_rating_cell" data-title="Reviews">
            <div
              class="stars w-stars blue"
              :style="'--rating: ' + course.average_review_rating + '; font-size: 15px;'"
              :aria-label="'Rating of this product is ' + course.average_review_rating + ' out of 5.'">
              <div class="ie-inner-stars" :style="'width: ' + ratingPercent(course.average_review_rating) + '%;'"></div>
            </div>
            <a
              :href="course.path + '#Reviews'"
              :aria-label="course.recommended_rating_count + ' reviews'"
              target="_blank"
              class="courses-table__rating-link">{{course.recommended_rating_count}}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import _ from 'lodash'
export default {
  props: {
    table: {
      type: Object,
      required: true
    },
    abbr: {
      type: String,
      required: false
    },
    toShowAbbr: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ratingPercent(rating) {
      return rating/5 * 100
    }
  },
  mounted() {
    const index = $('.home-shortcode-table').index()
    if (index < $('.sticky-container').index()) { // to remove margin if the shortcode is above the sticky-nav
      $('.home-shortcode-table table').addClass('before-sticky-nav')
    }
  }
}
</script>
